import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  text: {
    fontWeight: 400,
    fontSize: '15px'
  }
}));